import axios from '@/extensions/axios'

const actions = {
  get ({ commit }) {
    return axios.get('permissions')
      .then(({ data }) => {
        commit('SET', data)
      })
  },

  my ({ commit }) {
    return axios.get('permissions/my')
      .then(({ data }) => {
        commit('SET_MY', data)
      })
  }
}

export default actions
